import PropTypes from 'prop-types'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import RenderRichText from '@components/renderers/render-rich-text'
import defaults from '@config/defaults'
import { NextSeo } from 'next-seo'
import useStyles from './other.styles'

const Other = (props) => {
  const {
    headline,
    content,
    image,
    metaDescription,
    slug,
    route2,
  } = props
  const styles = useStyles()

  return (
    <div className={styles.other}>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={headline}
        description={metaDescription}
        canonical={`${defaults.baseUrl}${route2.substring(1)}${slug}`}
        openGraph={{
          title: headline,
          type: 'article',
          url: `${defaults.baseUrl}${route2.substring(1)}${slug}`,
          images: [{ url: (image && image.url) }],
        }}
      />
      <Container maxWidth="md">
        <Box pt={4} pb={6}>
          <Typography variant="h3" component="h1" align="center" gutterBottom>{headline}</Typography>
          {image && <img className={styles.img} src={image.url} alt={image.description} />}
        </Box>
        {content && <RenderRichText {...content} />}
      </Container>
    </div>
  )
}

Other.propTypes = {
  headline: PropTypes.string,
  slug: PropTypes.string,
  route2: PropTypes.string,
  metaDescription: PropTypes.string,
  content: PropTypes.shape({}),
  image: PropTypes.shape({
    url: PropTypes.string,
    description: PropTypes.string,
  }),
}

Other.defaultProps = {}

export default Other
